"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const react_i18next_1 = require("react-i18next");
const notificationLogFilterState_1 = __importDefault(require("./notificationLogFilterState"));
const userInfoState_1 = __importDefault(require("@/common/components/NavHeader/userInfoState"));
const isDataFetchingState_1 = __importDefault(require("@/common/functions/useIsDataFetching/isDataFetchingState"));
const functions_1 = require("@/common/functions");
const components_1 = require("@/common/components");
const material_ui_confirm_1 = require("material-ui-confirm");
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
function default_1({ showNotification }) {
    const { ready } = (0, recoil_1.useRecoilValue)(userInfoState_1.default);
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const profiles = (0, functions_1.useMultiProfile)({ ready, confirm });
    const resetNotificationLogFilter = (0, recoil_1.useResetRecoilState)(notificationLogFilterState_1.default);
    const [{ buyerFilter, channelFilter }, setNotificationLogFilter] = (0, recoil_1.useRecoilState)(notificationLogFilterState_1.default);
    const isAllFilterSelected = !channelFilter && !buyerFilter;
    const isBuyerFilterSelected = !channelFilter && buyerFilter;
    const isDataFetching = (0, recoil_1.useRecoilValue)(isDataFetchingState_1.default);
    const onAllFilterClick = () => {
        !isDataFetching && resetNotificationLogFilter();
    };
    const onBuyerFilterClick = () => {
        !isDataFetching && setNotificationLogFilter({ buyerFilter: true, channelFilter: 0 });
    };
    const onChannelFilterClick = (channelId) => {
        !isDataFetching && setNotificationLogFilter({ buyerFilter: false, channelFilter: channelId });
    };
    const { scrollDiv, setScrollDiv, centerTarget } = (0, functions_1.useHorizontalDragScroll)();
    (0, react_1.useEffect)(() => {
        if (showNotification && !!scrollDiv) {
            centerTarget(document.querySelector('#selected_log_filter'));
        }
    }, [channelFilter, buyerFilter, showNotification, scrollDiv]);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: setScrollDiv, className: "horizontal_drag_scroll no_scroll_bar surface-white", css: {
            columnGap: '8px',
            padding: '8px 11px',
            '.MuiToggleButton-root': {
                flexShrink: 0,
                height: '32px',
                borderRadius: '100px !important',
                border: '1px solid var(--gray-10) !important',
                backgroundColor: 'var(--white) !important',
                color: 'var(--gray-80)',
                lineHeight: '20px',
                fontSize: '14px',
                '&.Mui-selected': {
                    border: '0 !important',
                    backgroundColor: 'var(--gray-80) !important',
                    color: 'var(--white)',
                    fontWeight: 'bold',
                },
            },
        } }, { children: [(0, jsx_runtime_1.jsx)(ToggleButton_1.default, Object.assign({ value: "all_log", selected: isAllFilterSelected, id: isAllFilterSelected ? 'selected_log_filter' : undefined, onClick: onAllFilterClick, sx: { padding: '0 15px' } }, { children: t('전체') })), (0, jsx_runtime_1.jsx)(ToggleButton_1.default, Object.assign({ value: "buyer_log", selected: isBuyerFilterSelected, id: isBuyerFilterSelected ? 'selected_log_filter' : undefined, onClick: onBuyerFilterClick, sx: { padding: '0 15px' } }, { children: t('구매') })), profiles.map(profile => {
                const { id: channelId, thumbnail, name } = profile;
                const isChannelFilterSelected = channelFilter === channelId;
                return ((0, jsx_runtime_1.jsxs)(ToggleButton_1.default, Object.assign({ value: channelId, selected: isChannelFilterSelected, id: isChannelFilterSelected ? 'selected_log_filter' : undefined, onClick: () => onChannelFilterClick(channelId), sx: { alignItems: 'center', columnGap: '4px', padding: '0 10px 0 4px' }, translate: "no" }, { children: [(0, jsx_runtime_1.jsx)(components_1.RoundImage, { size: 24, src: thumbnail, altSrc: `${process.env.CDN_URL}/assets/svgs/default_profile.svg`, additionalCss: { borderRadius: '50%', backgroundColor: 'white' } }), `${name} ${t('판매')}`] }), `notification_channel_filter_${channelId}`));
            })] })));
}
exports.default = default_1;
